import { notifyError } from '../../utils/Notify';

export const matchPaymentWithJackpot = async (order, user, axiosInstance) => {

  function getFidCardNumber(user) {
    return user?.fidCard?.[0]?.fidelityInfo?.ficheClient?.numeroCarte;
  }

  const cardNumber = getFidCardNumber(user);
  const result = await axiosInstance.post('/fidelity-card/pay-with-jackpot', {
    orderId: order?._id,
    userId: user?._id,
    cardNumber: cardNumber,
    ...(!user?._id ? frontUser : user),
  });
  return result.data;
};

export const handleMatchPaymentWithJackpotError = (error) => {
  console.error(error.originalError.includes('Insufficient balance'))
  if (error.originalError.includes('Insufficient balance')) notifyError('Erreur', error.originalError);
  else if (error.errorCode === 'INTERNAL_SERVER_ERROR') notifyError('Erreur', 'Nous n\'avons pas réussi à joindre les serveurs de Match');
};
